/*
 * @Author: handan05
 * @Date: 2022-07-28 11:21:05
 * @LastEditors: handan05
 * @LastEditTime: 2023-06-13 11:57:34
 * @FilePath: /operation-utils/Users/handan/Documents/handan_work/58project/tech/wblog/src/platforms/pc.ts
 * @Description:
 */
import { isString } from '../../helpers';
import { ReportParams } from '../types';
import { getUid } from '../../helpers';

// 无线埋点下线灰度
const isOfflineWxLogGray = (scale: number) => {
    // 灰度100% 返回true
    if (scale * 1 === 100) return true;

    const uid: any = parseInt(getUid());
    const lastTwoDigits = uid % 100;
    return lastTwoDigits < scale;
};

// 格式化埋点query参数
const paramsFormat = (params: any = []) => {
    let result: any = [];
    for (const item in params) {
        let value: any = params[item];
        value = isString(value) ? value : JSON.stringify(value);
        result.push(`${item}=${value}`);
    }
    return result;
};

/**
 * 触发埋点
 *  pageType: pageType,
    actionType: commonParam.action,
    extJson: { ...this.defaultOpt.extJson, ...extJson, ...commonParam.extJson }
 */
function log(reportParams: ReportParams) {
    const { pageType, actionType, extJson = {}, options = {} } = reportParams;

    let params: any[] = [actionType, `pagetype=${pageType}`];

    let extJsonArr = paramsFormat(extJson);
    let optionsArr = paramsFormat(options);
    params = [...params, ...extJsonArr, ...optionsArr];

    // 恒星系统灰度10% 不上报
    const offlineHostnameList = ['employer.58.com', 'fabu.58.com', 'zppost.vip.58.com'];
    if (isOfflineWxLogGray(50) && offlineHostnameList.indexOf(window.location.hostname) !== -1) return;

    window.clickLog && window.clickLog('from=' + params.join('&'));
}
export default log;
